import TeacherService from "../../services/teacher.service";
import DashboardService from "../../services/dashboard.service";
const state = {
  teacher: null,
  filters: [],
  schoolYears: [],
  passageYears: {
    id: null,
    status: null,
  },
};
const getters = {
  getTeacher: (state) => state.teacher,
  geFilterTeacher: (state) => state.filters,
  getSchoolYears: (state) => state.schoolYears,
  getPassageYears: (state) => state.passageYears,
};
const mutations = {
  SET_DATA_TEACHER(state, payload) {
    if (payload.classes.length == 0) {
      payload.classes.push({id_class: null, name: null, courses: []});
    }
    state.teacher = payload;
  },
  SET_FILTER_TEACHER(state, payload) {
    state.filters = payload;
  },
  SET_SCHOOL_YEARS(state, payload) {
    state.schoolYears = payload;
  },
  SET_PASSAGE_YEARS(state, payload) {
    state.passageYears = {
      id: payload.id,
      status: payload.status,
    };
  },
};
const actions = {
  async getTeacherById({commit}, payload) {
    try {
      const response = await TeacherService.get(payload);
      commit("SET_DATA_TEACHER", response.data.data);
      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  },
  async getFiltreTeacher({commit}) {
    try {
      const {data} = await TeacherService.getFilterCourses();
      commit("SET_FILTER_TEACHER", data);
      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  },
  async updateTeacherStore({commit}, {id, payload}) {
    try {
      const response = await TeacherService.update(id, payload);
      commit("SET_DATA_TEACHER", response.data);
      return {success: true};
    } catch (error) {
      return {success: false, errors: error.response.data.errors};
    }
  },
  async fetchSchoolYears({commit}) {
    try {
      const {data} = await DashboardService.getSchoolYears();
      commit("SET_SCHOOL_YEARS", data.data);
    } catch (error) {
      console.error("error : ", error);
    }
  },
};
export default {
  getters,
  state,
  mutations,
  actions,
};
